import { AppDispatch, RootState } from 'src/store/store';
import { connect } from 'react-redux';
import ChildContainersPage from './ChildContainersPage';
import { GetContainerDetailsInput } from 'src/models/GetContainerDetails';
import { fetchContainerDetails } from 'src/store/common-slices/getContainerSlice';
import { SearchPages, setPageToRender } from 'src/store/common-slices/searchSlice';

const mapStateToProps = (state: RootState) => ({
    containerDetails: state.GetContainer.containerDetailsOutput,
    warehouseId: state.Init.initData.gradingNodeDetails.id,
    associate: state.Init.initData.associateDetails.id,
    locale: state.Init.initData.associateDetails.locales[0]
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
    fetchContainerDetails: (getContainerDetailsInput: GetContainerDetailsInput) => dispatch(fetchContainerDetails(getContainerDetailsInput)),
    setPageToRender: (pageToRender: SearchPages) => dispatch(setPageToRender(pageToRender))
});

export default connect(mapStateToProps, mapDispatchToProps)(ChildContainersPage);
